// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__qc5up","title":"AfterBackImages_title__14nOt","images":"AfterBackImages_images__2T0Zm"};